export const colors = {
    /* Buttons */
    originalBgColor: "#40CBE1",       // very light blue
    originalHoverColor: "#001529",    // dark blue
    originalColor: "#FFFFFF",         // white
    whiteColor: "#FFFFFF",         // white
    whiteHoverColor: "#16E1E1",    // sky blue
    successBgColor: "#008000",        // green
    successHoverColor: "#42A362",     // light green
    cancelBgColor: "#FF0000",         // red
    cancelHoverColor: "#F1807E",      // light red
    successCancelColor: "#FFFFFF",    // white

    /* Login */
    loginBgColor: "#ceeced",          // very light blue  "#40CBE1"
    loginFailedColor: "#FF5757",      // red +-

    /* Labels */
    errorLabelColor: "#d32f2f"        // red
};